import React from 'react'
// Icons
import {AiOutlineMenu} from 'react-icons/ai'


class MobileDropdown extends React.Component {
	state = {
		display: "none"
	}
	handleMenuToggle = (e) => {
		e.preventDefault()
		this.state.display === "none" ? this.setState({display: "flex"}) : this.setState({display: "none"})
	}
	render(){
		return(
		<div className="Mobile-links" >
			{/* <AiOutlineMenu onClick={this.handleMenuToggle}/> */}
			<a href="/Joseph Guzzardo Resume.pdf">Resume</a>
			<ul className="dropdown-content" style={{display: this.state.display, position: 'absolute' , top: '2em', left: '-100vw', zindex: 1}}>
				<a href="#about">About</a>
				<a href="#experience">Experience</a>
				<a href="#projects">Projects</a>
				<a href="#contact">Contact</a>
				<a href="/Joseph Guzzardo Resume.pdf">Resume</a>
			</ul>
		</div>
		)
	}
}

export default MobileDropdown